import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FirstButton from "../common/button";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {
  filters,
  // searchResult,
  about,
  list,
  list2,
  list3,
  list4,
  list5,
} from "../data/SearchData";
import Tooltip from "@mui/material/Tooltip";
import moment from "moment/moment";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import AccordionDetails from "@mui/material/AccordionDetails";
import {
  Card,
  TextField,
  CircularProgress,
  ToggleButton,
  ToggleButtonGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { Autocomplete } from "@mui/material";
import BreadCrumbs from "./BreadCrumbs";
import { Tabs } from "@mui/material";
import Tab from "@mui/material/Tab";
import TableChartIcon from "@mui/icons-material/TableChart";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import Dropdown from "../common/dropdown";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
import api from "../Axios";
import Pagination from "@mui/material/Pagination";
import noData from "../assets/images/noData.png";
import { useFormContext } from "../router/FormContext";

const ProductSearchPage = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState("1");
  const [searchTerms, setSearchTerms] = useState({});
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const [count, setCount] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const PAGE_SIZE = 10;
  
  const initialState = {
    Molecule: {
      ATCClass: null,
      DosageForm: null,
      RouteOfAdministration: null,
    },
    dates: {
      Before: "",
      US: "",
    },
    checkboxes: {
      Curated: false,
      SupplyWithSupply: false,
      SupplyTechTransfer: false,
    },
    ManufacturingFacilityLocation: [],
    DossierReadiness: [],
    RegionofInterest: [],
    supplyArray: { withSupply: false, techTransfer: false },
  };

  // const [formState, setFormState] = useState(initialState);
  const { search, setSearch, formState, setFormState, dossierViewMode: viewMode, setDossierViewMode: setViewMode } = useFormContext();
  const [searchResult, setSearchResult] = useState([]);
  const [spreadsheetData, setSpreadsheetData] = useState([]);
  const [isLoadingSpreadsheet, setIsLoadingSpreadsheet] = useState(false);
  const [checkformState, setCheckFormState] = useState(initialState);
  const SPREADSHEET_PAGE_SIZE = 1000;
  const urls = [
    { name: "Home", url: "/home" },
    { name: "Dossier Search", url: "" },
  ];
  useEffect(() => {
    window.scrollTo(0, 0);
    searchDossier(formState, "");
  }, []);

  useEffect(() => {
    if (viewMode === "spreadsheet" && count > 0) {
      setSpreadsheetData(searchResult);
      fetchSpreadsheetData();
    }
  }, [viewMode, count]);

  const getDossier = (page, search) => {
    setIsLoading(true);
    const data = {
      page: page,
      limit: 3,
      searchChar: search,
    };
    api
      .post("get-dossier", data)
      .then((resp) => {
        setSearchResult(resp?.data?.data);
        const totalObjects = resp?.data?.totalcount;
        setCount(totalObjects);
        const totalPages = Math.ceil(totalObjects / PAGE_SIZE);
        setTotalPage(totalPages);
        setPage(page);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleChange = (event, newValue) => {
    if (newValue === "1") {
      navigate("/dossier-search");
    } else if (newValue === "2") {
      navigate("/supplier-search");
    }
    setValue(newValue);
  };
  const handleSearchChange = (filterId, e) => {
    setSearchTerms({
      ...searchTerms,
      [filterId]: e.target.value.toLowerCase(),
    });
  };

  const handleDropdownChange = (key, value) => {
    const updatedState = {
      ...formState,
      Molecule: {
        ...formState.Molecule,
        [key]: value,
      },
    };
    setFormState(updatedState);

    searchDossier(updatedState);
  };

  const handleDateChange = (name, value) => {
    console.log(name, "Namer", value);
    const updatedState = {
      ...formState,
      dates: {
        ...formState.dates,
        [name]: value,
      },
    };
    setFormState(updatedState);

    searchDossier(updatedState);
  };

  const handleCheckboxChange = (category, name, checked) => {
    let updatedState = { ...formState };

    if (
      [
        "ManufacturingFacilityLocation",
        "DossierReadiness",
        "RegionofInterest",
      ].includes(category)
    ) {
      // Handling array-based categories
      updatedState = {
        ...formState,
        [category]: checked
          ? [...new Set([...(formState[category] || []), name])]
          : (formState[category] || []).filter((item) => item !== name),
      };
    } else if (category === "checkboxes") {
      // Normalize key names for checkboxes
      const normalizedKey = name.trim().replace(/[\s(),-]+/g, ""); // Remove unwanted characters

      updatedState = {
        ...formState,
        checkboxes: {
          ...formState.checkboxes,
          [normalizedKey]: checked,
        },
      };

      // Ensure "Supply" is not set as a general category
      delete updatedState.checkboxes["Supply"];
    }

    setFormState(updatedState);
    searchDossier(updatedState);
  };
  const handleSupplyChange = (itemSub) => {
    const normalizedKey =
      itemSub.trim().toLowerCase().replace(/\s+/g, "") === "withsupply"
        ? "withSupply"
        : "techTransfer";

    const updatedOperation = {
      withSupply: false,
      techTransfer: false,
      [normalizedKey]: true,
    };

    const updatedState = {
      ...formState,
      supplyArray: updatedOperation,
    };

    setFormState(updatedState);
    searchDossier(updatedState);
  };

  const buildSearchPayload = (updatedState, pageNo, searchData, limitSize) => {
    return {
      page:
        pageNo === "" || pageNo === null || pageNo === undefined ? 1 : pageNo,
      limit: limitSize ?? PAGE_SIZE,
      searchChar: searchData !== undefined ? searchData : search,
      therapCategory:
        updatedState?.Molecule?.ATCClass !== null
          ? updatedState?.Molecule?.ATCClass?.label
          : "",
      doseForm:
        updatedState?.Molecule?.DosageForm !== null
          ? updatedState?.Molecule?.DosageForm?.label
          : "",
      routeOfAdministration:
        updatedState.Molecule?.RouteOfAdministration !== null
          ? updatedState?.Molecule?.RouteOfAdministration?.label
          : "",
      usConstraintDate: updatedState?.dates?.US,
      RegionofInterest: updatedState?.RegionofInterest,
      DossierReadiness: updatedState?.DossierReadiness,
      countryOfManufacture: updatedState?.ManufacturingFacilityLocation,
      curated: updatedState?.checkboxes?.Curateddossiers,
      supplyStatus: updatedState?.supplyArray.withSupply
        ? ["With supply"]
        : updatedState?.supplyArray.techTransfer
          ? ["Tech transfer"]
          : [],
    };
  };

  const searchDossier = (updatedState, pageNo, searchData) => {
    setIsLoading(true);
    const data = buildSearchPayload(updatedState, pageNo, searchData);
    api
      .post("search-dossier", data)
      .then((resp) => {
        setSearchResult(resp?.data?.data);
        const totalObjects = resp?.data?.totalCount;
        setCount(totalObjects);
        const totalPages = Math.ceil(totalObjects / PAGE_SIZE);
        setTotalPage(totalPages);
        if (pageNo === "" || pageNo === null || pageNo === undefined) {
          setPage(1);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const fetchSpreadsheetData = () => {
    setIsLoadingSpreadsheet(true);
    const data = buildSearchPayload(
      formState,
      1,
      search,
      SPREADSHEET_PAGE_SIZE,
    );
    api
      .post("search-dossier", data)
      .then((resp) => {
        setSpreadsheetData(resp?.data?.data ?? []);
      })
      .catch((err) => {
        console.log(err);
        setSpreadsheetData([]);
      })
      .finally(() => {
        setIsLoadingSpreadsheet(false);
      });
  };

  const handlePageChange = (event, value) => {
    setPage(value);

    if (formState === checkformState) {
      getDossier(value, search);
    } else {
      searchDossier(formState, value);
    }
  };

  const handleViewModeChange = (event, newMode) => {
    if (newMode == null) return;
    setViewMode(newMode);
  };

  const resetState = () => {
    setFormState(initialState);
    searchDossier(initialState, page, "");
    setCheckFormState(initialState);
  };
  const handleRemoveFilter = (key) => {
    const updatedState = {
      ...formState,
      checkboxes: {
        ...formState.checkboxes,
        [key]: false, // Uncheck the selected value
      },
    };

    setFormState(updatedState);
    searchDossier(updatedState);
  };

  const handleRemoveArrayFilter = (category, value) => {
    const updatedState = {
      ...formState,
      [category]: formState[category].filter((item) => item !== value), // Remove the value from the array
    };

    setFormState(updatedState);
    searchDossier(updatedState);
  };

  return (
    <div className="search backgroundColor">
      <BreadCrumbs array={urls} />

      <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
      <div className="searchInput" style={{ margin: "0 auto" }}>
        <input
          className="login_input bg-white"
          placeholder="Search"
          style={{ width: "60%" }}
          value={search}
          onChange={(e) => {
            const value = e.target.value;
            setSearch(value);
            if (value.length === 0) {
              searchDossier(formState, "", "");
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              searchDossier(formState, "");
            }
          }}
        />

        <FirstButton
          buttonText={isLoading ? "Searching..." : "Submit"}
          onClick={(e) => {
            if (!isLoading) {
              searchDossier(formState, "");
              if (viewMode === "spreadsheet") {
                fetchSpreadsheetData();
              }
            }
          }}
          className={isLoading ? "btn-gray ms-2" : "btn ms-2"}
          disabled={isLoading}
        />               
      </div>
      <div className="dflex ">
        <div className="w20">
          <div className="dflex">
            <div className="mb-3 dflex">
              <FirstButton
                buttonText="Reset"
                onClick={resetState}
                className={
                  formState === checkformState ? "btn-gray ms-2" : "btn ms-2"
                }
              />
            </div>
            <h2 className="main_imgcont2 fs-20 fw-600 my-2">Filters</h2>
          </div>
        </div>
        <div className="w80 d-flex align-items-center justify-content-between flex-wrap gap-2">
          <h2 className="main_imgcont2 fs-20 fw-600 my-2 ">
            {isLoading ? "Searching..." : `${count} dossiers found`}
          </h2>
          {count > 0 && (
            <div
              className="d-inline-flex align-items-center"
              style={{ height: 38 }}
            >
              <ToggleButtonGroup
                value={viewMode}
                exclusive
                onChange={handleViewModeChange}
                size="small"
                sx={{
                  height: "100%",
                  "& .MuiToggleButton-root": {
                    py: 0,
                    px: 1.5,
                    height: "100%",
                    minHeight: 38,
                  },
                }}
              >
                <ToggleButton value="cards" aria-label="card view">
                  <ViewModuleIcon sx={{ mr: 0.5 }} fontSize="small" />
                  Cards
                </ToggleButton>
                <ToggleButton value="spreadsheet" aria-label="spreadsheet view">
                  <TableChartIcon sx={{ mr: 0.5 }} fontSize="small" />
                  Spreadsheet
                </ToggleButton>
              </ToggleButtonGroup>
            </div>
          )}
        </div>
      </div>
      <div className="dflex " style={{ minHeight: "600px", alignItems: "flex-start" }}>
        <div className="w20 m121">
          {filters &&
            filters.map((item, index) => (
              <Accordion key={index}>
                <AccordionSummary
                  expandIcon={<ArrowDownwardIcon />}
                  aria-controls={`panel${index}-content`}
                  id={`panel${index}-header`}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "100%",
                    }}
                  >
                    <h4>{item.name}</h4>

                    {/* Selected Values Display */}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "8px",
                        marginTop: "5px",
                      }}
                    >
                      {item.id === 1 &&
                        Object.entries(formState.Molecule)
                          .filter(([key, value]) => value?.label) // Ensure value exists and has label
                          .map(([key, value]) => (
                            <span key={key} className="selectedText">
                              {value.label}
                              <button
                                className="selected-cancel-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDropdownChange(key, null);
                                }}
                              >
                                ✖
                              </button>
                            </span>
                          ))}
                      {item.id === 4 &&
                        formState.ManufacturingFacilityLocation.length > 0 &&
                        formState.ManufacturingFacilityLocation.map(
                          (value, idx) => (
                            <span key={idx} className="selectedText">
                              {value}
                              <button
                                className="selected-cancel-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveArrayFilter(
                                    "ManufacturingFacilityLocation",
                                    value,
                                  );
                                }}
                              >
                                ✖
                              </button>
                            </span>
                          ),
                        )}

                      {item.id === 5 &&
                        formState.DossierReadiness.length > 0 &&
                        formState.DossierReadiness.map((value, idx) => (
                          <span key={idx} className="selectedText">
                            {value}
                            <button
                              className="selected-cancel-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveArrayFilter(
                                  "DossierReadiness",
                                  value,
                                );
                              }}
                            >
                              ✖
                            </button>
                          </span>
                        ))}

                      {item.id === 2 &&
                        formState?.RegionofInterest?.length > 0 &&
                        formState?.RegionofInterest.map((value, idx) => (
                          <span key={idx} className="selectedText">
                            {value}
                            <button
                              className="selected-cancel-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveArrayFilter(
                                  "RegionofInterest",
                                  value,
                                );
                              }}
                            >
                              ✖
                            </button>
                          </span>
                        ))}

                      {item.id === 3 &&
                        Object.entries(formState.dates)
                          .filter(([key, value]) => value) // Ensure value is not empty
                          .map(([key, value]) => (
                            <span key={key} className="selectedText">
                              {moment(value).format("MMM YYYY")}
                              <button
                                className="selected-cancel-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDateChange(key, ""); // Clear the value correctly
                                }}
                              >
                                ✖
                              </button>
                            </span>
                          ))}
                      {Object.keys(formState.checkboxes)
                        .filter((key) =>
                          key.startsWith(item.name.replace(/[\s(),-]+/g, "")),
                        ) // Match category
                        .filter((key) => formState.checkboxes[key]) // Only selected values
                        .map((key) => (
                          <span key={key} className="selectedText">
                            {key.replace(
                              item.name.replace(/[\s(),-]+/g, ""),
                              "",
                            )}
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveFilter(key);
                              }}
                              className="selected-cancel-btn"
                            >
                              ✕
                            </button>
                          </span>
                        ))}
                    </div>
                  </div>
                </AccordionSummary>
                <AccordionDetails className="px-3 py-2 text-start">
                  {item.subFilters && item.id !== 1 && item.id !== 3 && (
                    <TextField
                      variant="outlined"
                      size="small"
                      placeholder="Search"
                      fullWidth
                      value={searchTerms[item.id] || ""}
                      onChange={(e) => handleSearchChange(item.id, e)}
                      style={{ marginBottom: "1rem" }}
                    />
                  )}

                  {item.subFilters &&
                    item.subFilters
                      .filter(
                        (itemSub) =>
                          !searchTerms[item.id] ||
                          itemSub.toLowerCase().includes(searchTerms[item.id]),
                      )
                      .map((itemSub, subIndex) => (
                        <AccordionDetails
                          key={subIndex}
                          // className="px-3 py-2"
                          className={
                            item?.id === 1 && subIndex === 2
                              ? "px-3 py-2 mb-40"
                              : "px-3 py-2"
                          }
                        >
                          {item.id === 1 ? (
                            <Autocomplete
                              name="filter"
                              // defaultValue={dValue}
                              options={
                                subIndex === 0 ? (
                                  list
                                ) : subIndex === 1 ? (
                                  list2
                                ) : subIndex === 2 ? (
                                  list3
                                ) : subIndex === 3 ? (
                                  list4
                                ) : subIndex === 4 ? (
                                  list5
                                ) : (
                                  <></>
                                )
                              }
                              className="basic-multi-select"
                              value={
                                subIndex === 0
                                  ? formState?.Molecule?.ATCClass
                                  : subIndex === 1
                                    ? formState?.Molecule?.DosageForm
                                    : subIndex === 2
                                      ? formState?.Molecule
                                          ?.RouteOfAdministration
                                      : ""
                                // formState.Molecule[`dropdown${subIndex + 1}`]
                              }
                              // classNamePrefix="select"
                              onChange={(event, newValue) => {
                                handleDropdownChange(
                                  subIndex === 0
                                    ? "ATCClass"
                                    : subIndex === 1
                                      ? "DosageForm"
                                      : subIndex === 2
                                        ? "RouteOfAdministration"
                                        : "", // Handle additional cases if needed
                                  newValue,
                                );
                              }}
                              // styles={colourStyles}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  // variant="outlined"
                                  label={
                                    subIndex === 0
                                      ? "Therapeutic Category"
                                      : subIndex === 1
                                        ? "Dosage Form"
                                        : "Route Of Administration"
                                  }
                                />
                              )}
                            />
                          ) : (
                            <FormControlLabel
                              control={
                                item.id === 3 ? (
                                  <Tooltip
                                    title={
                                      <span style={{ fontSize: "14px" }}>
                                        This date reflects the estimated end of
                                        fda granted exclusivities . However,
                                        additional patents or legal constraints
                                        may still apply. Buyers are advised to
                                        conduct their own due diligence before
                                        assuming generic launch readiness.
                                      </span>
                                    }
                                    arrow
                                  >
                                    <TextField
                                      type="month"
                                      className="p-2 me-4"
                                      value={formState.dates.US ?? ""}
                                      onChange={(e) =>
                                        handleDateChange(
                                          itemSub,
                                          e.target.value,
                                        )
                                      }
                                      InputLabelProps={{ shrink: true }}
                                      variant="outlined"
                                      size="small"
                                      inputProps={{
                                        style: {
                                          padding: "6px 8px",
                                          fontSize: "12px",
                                          width: "110px",
                                        },
                                      }}
                                      sx={{
                                        width: "auto",
                                        minWidth: "120px",
                                      }}
                                    />
                                  </Tooltip>
                                ) : item?.id === 8 ? (
                                  <>
                                    <input
                                      type="radio"
                                      name="supplyRadio"
                                      value={itemSub}
                                      className="p-2 me-3"
                                      checked={
                                        formState.supplyArray?.[
                                          itemSub
                                            .trim()
                                            .toLowerCase()
                                            .replace(/\s+/g, "") ===
                                          "withsupply"
                                            ? "withSupply"
                                            : "techTransfer"
                                        ] === true
                                      }
                                      onChange={() =>
                                        handleSupplyChange(itemSub)
                                      }
                                    />
                                  </>
                                ) : (
                                  <>
                                    <Checkbox
                                      checked={
                                        item.id === 4
                                          ? (
                                              formState.ManufacturingFacilityLocation ||
                                              []
                                            ).includes(itemSub)
                                          : item.id === 5
                                            ? (
                                                formState.DossierReadiness || []
                                              ).includes(itemSub)
                                            : item.id === 2
                                              ? (
                                                  formState.RegionofInterest ||
                                                  []
                                                ).includes(itemSub)
                                              : item.id === 6
                                                ? formState.checkboxes?.[
                                                    itemSub
                                                      .trim()
                                                      .replace(/[\s(),-]+/g, "")
                                                      .replace(
                                                        /^Withsupply$/i,
                                                        "SupplyWithSupply",
                                                      )
                                                      .replace(
                                                        /^Techtransfer$/i,
                                                        "SupplyTechTransfer",
                                                      )
                                                  ] || false
                                                : formState.checkboxes?.[
                                                    item.name
                                                      .trim()
                                                      .replace(
                                                        /[\s(),-]+/g,
                                                        "",
                                                      ) +
                                                      itemSub
                                                        .trim()
                                                        .replace(
                                                          /[\s(),-]+/g,
                                                          "",
                                                        )
                                                  ] || false
                                      }
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          item.id === 4
                                            ? "ManufacturingFacilityLocation"
                                            : item.id === 5
                                              ? "DossierReadiness"
                                              : item.id === 2
                                                ? "RegionofInterest"
                                                : "checkboxes",
                                          itemSub
                                            .trim()
                                            .replace(
                                              /^Withsupply$/i,
                                              "SupplyWithSupply",
                                            )
                                            .replace(
                                              /^Techtransfer$/i,
                                              "SupplyTechTransfer",
                                            ),
                                          e.target.checked,
                                        )
                                      }
                                      sx={{
                                        color: "#00adfc",
                                        "&.Mui-checked": { color: "#00adfc" },
                                        "& .MuiSvgIcon-root": { fontSize: 24 },
                                      }}
                                    />
                                  </>
                                )
                              }
                              label={itemSub}
                            />
                          )}
                        </AccordionDetails>
                      ))}
                </AccordionDetails>
              </Accordion>
            ))}
        </div>
        {isLoading && viewMode === "cards" ? (
          <div
            className="w60 d-flex justify-content-center align-items-center"
            style={{ minHeight: "400px" }}
          >
            <CircularProgress size={60} sx={{ color: "#7915cf" }} />
          </div>
        ) : viewMode === "spreadsheet" && count > 0 ? (
          <div className="w80" style={{ overflowX: "auto" }}>
            {isLoadingSpreadsheet && spreadsheetData.length <= PAGE_SIZE && (
              <div className="d-flex align-items-center gap-2 mb-2" style={{ fontSize: "0.875rem", color: "#666" }}>
                <CircularProgress size={16} sx={{ color: "#7915cf" }} />
                <span>Loading full list (up to 1000 rows)…</span>
              </div>
            )}
            <TableContainer
                component={Paper}
                sx={{
                  maxHeight: "75vh",
                  "& .MuiTableHead-root": { position: "sticky", top: 0, zIndex: 1, backgroundColor: "#f5f5f5" },
                  "& .MuiTableCell-head": { fontSize: "1rem", fontWeight: 600 },
                  "& .MuiTableCell-body": { fontSize: "1rem" },
                }}
              >
                <Table stickyHeader sx={{ "& .MuiTableCell-root": { fontSize: "1rem" } }}>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600, fontSize: "1rem" }}>Title</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: "1rem" }}>Dose Form</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: "1rem" }}>Offer (days)</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: "1rem" }}>Available geographies</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: "1rem" }}>Dossier status</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: "1rem" }}>Curated</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: "1rem" }}>Manufacturing GMP</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: "1rem" }}>Country of manufacture</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: "1rem" }}>Supply</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: "1rem" }}>Type</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: "1rem" }}>Code</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {spreadsheetData.map((row) => (
                      <TableRow
                        key={row?._id}
                        hover
                        sx={{
                          "&:hover": { backgroundColor: "action.hover" },
                          cursor: "pointer",
                          "& .MuiTableCell-root": { fontSize: "1rem" },
                        }}
                        onClick={() => navigate(`/product-details/${row?._id}`)}
                      >
                        <TableCell sx={{ maxWidth: 200, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: "1rem" }}>
                          {row?.ListingTitle ?? "—"}
                        </TableCell>
                        <TableCell sx={{ fontSize: "1rem" }}>
                          {[row?.doseForm, row?.resCapsules].filter(Boolean).join(" ") || "—"}
                        </TableCell>
                        <TableCell sx={{ fontSize: "1rem" }}>{row?.offDay != null ? `${row.offDay} business days` : "—"}</TableCell>
                        <TableCell sx={{ maxWidth: 120, fontSize: "1rem" }}>
                          {row?.locations?.length ? row.locations.join(", ") : "—"}
                        </TableCell>
                        <TableCell sx={{ fontSize: "1rem" }}>{row?.dosStatus ?? "—"}</TableCell>
                        <TableCell sx={{ fontSize: "1rem" }}>{typeof row?.curated === "boolean" ? (row.curated ? "Yes" : "No") : "—"}</TableCell>
                        <TableCell sx={{ maxWidth: 120, fontSize: "1rem" }}>
                          {row?.mfg?.length ? row.mfg.join(", ") : "—"}
                        </TableCell>
                        <TableCell sx={{ maxWidth: 120, fontSize: "1rem" }}>
                          {row?.com?.length ? row.com.join(", ") : "—"}
                        </TableCell>
                        <TableCell sx={{ maxWidth: 100, fontSize: "1rem" }}>
                          {row?.supply?.length ? row.supply.join(", ") : "—"}
                        </TableCell>
                        <TableCell sx={{ fontSize: "1rem" }}>{row?.type ?? "—"}</TableCell>
                        <TableCell sx={{ fontSize: "1rem" }}>{row?.ListingCode ?? "—"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
          </div>
        ) : count > 0 ? (
          <>
            <div className="w80">
              {searchResult &&
                searchResult.map((sitem, index) => (
                  <div key={sitem?._id}>
                    <div>
                      <div
                        className="ph-spcardmain bg-white"
                        onClick={() =>
                          navigate(`/product-details/${sitem?._id}`)
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <div className="ph-cardsphead">
                          <div>
                            {sitem?.curated ? (
                              <p className="pdcurated ">
                                <span className="mb-1 me-1">
                                  <CheckCircleSharpIcon />
                                </span>
                                PD Curated
                              </p>
                            ) : (
                              <></>
                            )}
                            <div className="d-flex">
                              <h2 className="fs-24 fw-600 cursor-pointer title-hover">
                                {sitem?.ListingTitle}
                              </h2>
                            </div>
                            <p className="ph-cardspp">
                              {[sitem?.doseForm, sitem?.resCapsules]
                                .filter(Boolean)
                                .join(" ")}
                            </p>
                          </div>
                          <div style={{ textAlign: "right" }}>
                            <FirstButton
                              buttonText="Enquire"
                              className="enquire-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/product-term-sheet/${sitem?._id}`);
                              }}
                            />
                            <p className="offer-font">
                              Offer in {sitem?.offDay} business days
                            </p>
                          </div>
                        </div>
                        <div className="ph-cardspbody">
                          <div>
                            {sitem?.locations?.length > 0 && (
                              <p className="ph-cardspp">
                                Available geographies -{" "}
                                {sitem.locations.join(", ")}
                              </p>
                            )}

                            {sitem?.dosStatus && (
                              <p className="ph-cardspp">
                                Dossier status - {sitem.dosStatus}
                              </p>
                            )}

                            {typeof sitem?.curated === "boolean" && (
                              <p className="ph-cardspp">
                                Curated - {sitem.curated ? "Yes" : "No"}
                              </p>
                            )}

                            {sitem?.mfg?.length > 0 && (
                              <p className="ph-cardspp">
                                Manufacturing GMP - {sitem.mfg.join(", ")}
                              </p>
                            )}
                          </div>

                          <div>
                            {sitem?.com?.length > 0 && (
                              <p className="ph-cardspp">
                                Country of manufacture - {sitem.com.join(", ")}
                              </p>
                            )}

                            {sitem?.usConDate &&
                              sitem.usConDate !== "01-Jan-1900" && (
                                <p className="ph-cardspp">
                                  US constraint date - {sitem.usConDate}
                                </p>
                              )}

                            {sitem?.supply?.length > 0 && (
                              <p className="ph-cardspp">
                                Supply - {sitem.supply.join(", ")}
                              </p>
                            )}

                            {sitem?.type && (
                              <p className="ph-cardspp">Type - {sitem.type}</p>
                            )}
                          </div>
                        </div>

                        <div className="mt-2">
                          {sitem?.ListingCode && (
                            <h3 className="ph-cardspp">
                              Code : {sitem?.ListingCode}
                            </h3>
                          )}
                          <p className="ph-cardspp lh-base text-justify">
                            {sitem?.descp}
                            <span
                              className="text-info sidebar_close"
                              onClick={() =>
                                navigate(`/product-details/${sitem?._id}`)
                              }
                            >
                              more...
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </>
        ) : (          
          <div className="w80">
            <Card className="px-2 w100">
              <div className="d-flex flex-column align-items-center p-5">
                <img
                  src={noData}
                  style={{ width: "25%", height: "auto" }}
                  alt="No data found"
                />
                <p className="text-center fs-16 fw-500 light-text-color mt-3">
                  No Dossier Found
                </p>
                <p className="text-center fs-14 light-text-color">
                  Try adjusting your search criteria or filters
                </p>
              </div>
            </Card>
          </div>
        )}
      </div>
      <div className="d-flex justify-center">
        {viewMode === "cards" && !isLoading && count > 0 && totalPage > 1 && (
          <Pagination
            count={totalPage}
            page={page}
            defaultPage={1}
            variant="outlined"
            onChange={handlePageChange}
            shape="rounded"
          />
        )}
      </div>
      </div>
    </div>
  );
};

export default ProductSearchPage;
